import { FraudCheckStatus, KountCheckStatus } from '@occc/graphql';

export const REFERRAL_PROGRAM_LABEL = 'Referral Program';
export const REFERRAL_PROGRAM_DETAILS_PATH = '/program-management/referral-program';

const FLAGGED_FRAUD_CHECK_LABEL = 'Flagged';
const SAFE_FRAUD_CHECK_LABEL = 'Safe';

export const labelByFraudCheckStatus: Record<FraudCheckStatus, string> = {
  [FraudCheckStatus.Fraudulent]: FLAGGED_FRAUD_CHECK_LABEL,
  [FraudCheckStatus.NotFraudulent]: SAFE_FRAUD_CHECK_LABEL,
  [FraudCheckStatus.NotChecked]: 'UnConfirmed',
};

export const labelByKountCheckStatus: Record<KountCheckStatus, string> = {
  [KountCheckStatus.Fraudulent]: FLAGGED_FRAUD_CHECK_LABEL,
  [KountCheckStatus.NotFraudulent]: SAFE_FRAUD_CHECK_LABEL,
};
